import { useState } from "react";
import { heroTags } from "@/mocks/home";

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20editorial%20background%20with%20deep%20crimson%20and%20charcoal%20ink%20smoke%20textures%2C%20dramatic%20cinematic%20lighting%2C%20high%20contrast%2C%20mysterious%20moody%20atmosphere%2C%20subtle%20film%20grain%2C%20no%20people%2C%20suitable%20for%20dark%20overlay%20text&width=1600&height=900&seq=heihiao-hero-2026-a1&orientation=landscape"
          alt="17黑料网深度解析主视觉背景"
          title="17黑料网 深度解析 背后真相 动机分析 关联人物全貌"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/85"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-site flex-col items-center px-4 pb-16 pt-32 text-center md:px-8 md:pb-20 md:pt-40">
        <span className="animate-fade-up inline-flex items-center gap-2 rounded-full border border-background-100/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium tracking-[0.2em] text-background-100 backdrop-blur">
          <i className="ri-pulse-line text-sm text-accent-400"></i>
          DEEP ANALYSIS · 深度解析
        </span>

        <h1
          className="animate-fade-up mt-7 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl"
          style={{ animationDelay: "0.1s" }}
        >
          17黑料网 <span className="text-accent-400">深度解析</span>
        </h1>

        <p
          className="animate-fade-up mt-5 max-w-2xl text-sm leading-8 text-background-100/85 md:text-base"
          style={{ animationDelay: "0.2s" }}
        >
          还原事件背后的真相与动机链条，从利益关系到关联人物，拆解热点黑料的完整脉络。
          我们呈现全貌而非片段，帮你理解舆论场中的复杂博弈与真实走向。
        </p>

        <div
          className="animate-fade-up mt-9 w-full max-w-xl"
          style={{ animationDelay: "0.3s" }}
        >
          <div className="flex items-center gap-2 rounded-lg border border-background-100/20 bg-background-50/10 p-1.5 backdrop-blur">
            <span className="ml-2 flex h-9 w-9 items-center justify-center text-background-100/70">
              <i className="ri-search-2-line text-lg"></i>
            </span>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入热点关键词，开始拆解脉络"
              className="h-10 flex-1 bg-transparent text-sm text-background-50 placeholder:text-background-100/55 focus:outline-none"
            />
            <button
              type="button"
              className="h-10 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              开始解析
            </button>
          </div>
          <p className="mt-3 text-xs text-background-100/55">
            示例：解约风波 · 分成比例 · 账号归属 · 舆情反转
          </p>
        </div>

        <div
          className="animate-fade-up mt-8 flex flex-wrap items-center justify-center gap-2"
          style={{ animationDelay: "0.4s" }}
        >
          {heroTags.map((tag) => (
            <a
              key={tag}
              href="#topics"
              className="cursor-pointer whitespace-nowrap rounded-full border border-background-100/20 px-3.5 py-1.5 text-xs text-background-100/85 transition-colors hover:border-accent-400/60 hover:text-accent-400"
            >
              # {tag}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}